import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=7399604c&scoped=true&"
import script from "./LanguageButton.vue?vue&type=script&lang=ts&"
export * from "./LanguageButton.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=7399604c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7399604c",
  null
  
)

export default component.exports